export default 'https://tme.understood.org/assets/outro.en.55d342fa.vtt'